import { DashUnderlineProps } from '../../atoms/DashUnderline';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';


type HeaderCellInternalProps = {
  text?: TextProps;
  icon?: IconProps;
  dashUnderline?: DashUnderlineProps;
};

type HeaderCellPropsValues = {
  'AscendingDefaultL': HeaderCellInternalProps;
  'AscendingDefaultM': HeaderCellInternalProps;
  'AscendingTooltipL': HeaderCellInternalProps;
  'AscendingTooltipM': HeaderCellInternalProps;
  'DefaultDefaultL': HeaderCellInternalProps;
  'DefaultDefaultM': HeaderCellInternalProps;
  'DefaultTooltipL': HeaderCellInternalProps;
  'DefaultTooltipM': HeaderCellInternalProps;
  'DescendingDefaultL': HeaderCellInternalProps;
  'DescendingDefaultM': HeaderCellInternalProps;
  'DescendingEmptyL': HeaderCellInternalProps;
  'DescendingTooltipL': HeaderCellInternalProps;
  'DescendingTooltipM': HeaderCellInternalProps;
  'DescendingEmptyFullWidth': HeaderCellInternalProps;
};

const propValues: HeaderCellPropsValues = {
  'AscendingDefaultL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'ArrowUp',
      colour: 'IconPrimary',
    },
  },
  'AscendingDefaultM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'ArrowUp',
      colour: 'IconPrimary',
    },
  },
  'AscendingTooltipL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'ArrowUp',
      colour: 'IconPrimary',
    },
  },
  'AscendingTooltipM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'ArrowUp',
      colour: 'IconPrimary',
    },
  },
  'DefaultDefaultL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'Sort',
      colour: 'IconPrimary',
    },
  },
  'DefaultDefaultM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'Sort',
      colour: 'IconPrimary',
    },
  },
  'DefaultTooltipL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'Sort',
      colour: 'IconPrimary',
    },
  },
  'DefaultTooltipM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'Sort',
      colour: 'IconPrimary',
    },
  },
  'DescendingDefaultL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'ArrowDown',
      colour: 'IconPrimary',
    },
  },
  'DescendingDefaultM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    icon: {
      asset: 'ArrowDown',
      colour: 'IconPrimary',
    },
  },
  'DescendingEmptyL': {
  },
  'DescendingTooltipL': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'ArrowDown',
      colour: 'IconPrimary',
    },
  },
  'DescendingTooltipM': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    dashUnderline: {
    },
    icon: {
      asset: 'ArrowDown',
      colour: 'IconPrimary',
    },
  },
  'DescendingEmptyFullWidth': {
  },
};

const getProps = (type: string): HeaderCellInternalProps => {
  const values: HeaderCellInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
